import type { ReactElement } from "react";
import { useMemo } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";
import type { IAppsPermissionsFilter } from "app/pages/sales-intelligence/store/find-apps/types";

const AppPermissionsFilterResult = ({
    value,
    isExpanded,
    onFilterUpdate,
}: IFilterViewBaseModelProps<IAppsPermissionsFilter>): ReactElement | null => {
    const chipItems = useMemo((): ChipItem[] => {
        if (!value?.permissions?.length) {
            return [];
        }

        return value.permissions.map((permission) => ({ id: permission, text: permission }));
    }, [value?.permissions]);

    if (!chipItems.length || !value?.operator) {
        return null;
    }

    const operator = value.operator.toLocaleUpperCase();

    const handleOnChipClose = (closedPermission: string): void => {
        const permissions = value.permissions.filter((permission) => permission !== closedPermission);

        if (!permissions.length) {
            onFilterUpdate();
            return;
        }

        onFilterUpdate({
            ...value,
            permissions,
        });
    };

    return (
        <Flex
            flexWrap="wrap"
            alignItems="baseline"
        >
            <LimitedChipItems
                items={chipItems}
                onDelete={handleOnChipClose}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                delimiter={operator}
                isTabExpanded={isExpanded}
            />
        </Flex>
    );
};

export default AppPermissionsFilterResult;
